import React from 'react'
import styled from 'styled-components'

const BannerContainer = styled.div`
  margin: 1rem auto;
`

const Heading = styled.h3`
  color: var(--Text700);
  margin: 0.5rem auto;
  width: 100%;
  max-width: 600px;
  text-transform: capitalize;
  @media (max-width: 600px) {
    width: 100%;
    max-width: 98%;
  }
`

const BannerImageContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0.5rem auto;
  border-radius: 8px;
  display: flex;
  cursor: pointer;
  transition: all 0.2s;

  @media (max-width: 600px) {
    width: 100%;
    max-width: 98%;
  }
`

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: inherit;
`

const Banner = ({ title, contentLink,bannerSrc }) => {
  const navigateToBannerContentHandler = () => {
    if (contentLink) {
      window.location.assign(contentLink)
    }
  }

  return (
    <BannerContainer>
      <Heading>{title}</Heading>
      <BannerImageContainer onClick={navigateToBannerContentHandler}>
        <BannerImage src={bannerSrc} alt="Banner" />
      </BannerImageContainer>
    </BannerContainer>
  )
}

export default Banner
